/**
 * A Home component for the redux presentation.
 * @author [Douglas Rodrigues](https://github.com/douglasrodrigues5)
 * @module Components/HomeView
 * @license MIT
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import images from '../../assets/images';
import { loadLogo } from '../../helpers/logo';
// import About from '../../components/containers/About';
// import HowWorks from '../../components/containers/HowWorks';
// import Benefits from '../../components/Benefits';
// import OurBrands from '../../components/containers/OurBrands';
// import MyPrizes from '../../components/containers/MyPrizes';
import { brandsMock, stepsMock } from './mocks';
console.log('images', images);
/**
 * Home component class
 * @class HomeView
 * @extends React.Component
 */
export default class HomeView extends Component {
  render() {
    return (
      <div>
        <div id="topo" className="image-top"></div>
        <div className="p-4 p-lg-0">
          <div id="container" className="container content">
            {/* <About avatar={images.stocks.family_buying} logo={images.logo[loadLogo(process.env.BRAND_INITIALS, 'small')]} {...this.props} /> */}
            {/* <HowWorks deckList={stepsMock} /> */}
            {/* <Benefits /> */}
          </div>
        </div>
        {/* <MyPrizes
          cellphone={images.stocks.my_awards_cellphone}
          cellphone2={images.stocks.my_discount_cellphone}
          myAwards={images.stocks.my_awards}
          myAwardsMobile={images.stocks.my_awards_mobile}
          myDiscount={images.stocks.my_discount}
          myDiscountMobile={images.stocks.my_discount_mobile}
          google_play={images.icons.google_play}
          app_store={images.icons.app_store} />
        <OurBrands brandList={brandsMock} /> */}
      </div>
    );
  }
}

HomeView.propTypes = {
  /**
   * Some info to handle
   * @type {any}
   */
  info: PropTypes.any,
  /**
   * The function passed by the connector to communicate with the reducer.
   * @type {function}
   */
  actionTarget: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/pages/home/HomeView.js